<template>
  <v-btn color="success" rounded @click="nextStep()" :block="isMobile()" outlined class="font-weight-bold" min-width="180" height="30"
    >Continuar <v-icon left>mdi-arrow-right</v-icon></v-btn
  >
</template>

<script>
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations("formacaoCarga", ["nextStep"]),
    isMobile(){
        return this.$mq == 'sm'
    }
  },
};
</script>

<style>
</style>